const angular = require('angular');
const ngMessages = require('angular-messages');
const uiRouter = require('angular-ui-router');
const restangular = require('restangular'); // eslint-disable-line no-unused-vars

const wowCommonModule = require('../common/common.module');
const olyCommonModule = require('../olycommon/olycommon.module');

const authModuleName = 'wowApp.auth';

angular.module(authModuleName, [olyCommonModule, wowCommonModule, ngMessages, uiRouter, 'restangular']);

// ------------------------------------------
// Components
// ------------------------------------------
require('./login');
require('./shopper');
require('./signup');
require('./resetpassword');
require('./forgotpassword');

module.exports = authModuleName;



// WEBPACK FOOTER //
// ./src/auth/auth.module.js